
const staffRoleManagement = () => import('@/views/main/staff/role-management/role-management.vue')
export default {
  path: '/main/staff/roleManagement',
  name: 'staffRoleManagement',
  component: staffRoleManagement,
  children: []
}

